import { Chip } from '@mui/material'
import { Close } from '@mui/icons-material'

type FilterChipProps = {
  label: string
  onDelete: () => void
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, onDelete }) => {
  return (
    <Chip
      key={'${label}-active-filter'}
      onDelete={onDelete}
      label={label}
      sx={{ width: 'fit-content' }}
    />
  )
}
